import ProxyBase from '../../../../../core/proxies/ProxyBase'

class CategoryProxy extends ProxyBase {
  postCategoryCheckData(params) {
    return this.post('CheckDataAvailabilityRequest', params)
  }
}

export default new CategoryProxy('CartAndOrder/')
